import { render, staticRenderFns } from "./DependencyApplicationsIndex.vue?vue&type=template&id=4dc3320f&"
import script from "./DependencyApplicationsIndex.vue?vue&type=script&lang=js&"
export * from "./DependencyApplicationsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports